import { Link } from 'react-router-dom'
import { MapPin, Briefcase, ArrowRight } from 'lucide-react'
import { getMediaUrl } from '../utils/media'

const CarteProjet = ({ projet }) => {
  return (
    <div className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-all border border-gray-100 flex flex-col h-full">
      <div className="relative h-48 overflow-hidden">
        <img 
          src={getMediaUrl(projet.miniature_image, 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=800')} 
          alt="Illustration du projet"
          onError={(e) => {
            e.target.onerror = null; 
            e.target.src = 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=800';
          }}
          className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
        />
        <div className="absolute bottom-4 left-4">
          <span className="bg-cidh-blue text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider">
            {projet.secteur}
          </span>
        </div>
      </div>
      
      <div className="p-8 flex-grow flex flex-col">
        <h3 className="text-xl font-bold mb-3 text-cidh-blue line-clamp-2 leading-tight">
          {projet.nom_mission}
        </h3>
        <p className="text-gray-500 text-sm mb-6 line-clamp-3">
          {projet.description_projet ? projet.description_projet.replace(/<[^>]*>?/gm, '').substring(0, 150) + '...' : ''}
        </p>
        
        <div className="mt-auto space-y-2 mb-6">
          <div className="flex items-center gap-2 text-xs text-gray-500">
            <MapPin size={14} className="text-cidh-gold" />
            <span>Région: {projet.region}</span>
          </div>
          <div className="flex items-center gap-2 text-xs text-gray-500">
            <Briefcase size={14} className="text-cidh-gold" />
            <span>Autorité: {projet.autorite_contractante}</span>
          </div>
        </div>
        
        <Link 
          to={`/projets/${projet.id}`} 
          className="w-full text-center py-2 bg-cidh-gold text-white font-semibold rounded-md hover:bg-opacity-90 transition-all flex items-center justify-center gap-2"
        >
          En savoir plus <ArrowRight size={16} />
        </Link>
      </div>
    </div>
  )
}

export default CarteProjet
